import React from 'react';
import { X, ZoomIn, ZoomOut } from 'lucide-react';

const MenuItem = ({ item, isDarkMode, onPick }) => {
  const Icon = item.icon;
  return (
    <button
      onClick={() => { item.onClick(); if (!item.keepOpen) onPick(); }}
      disabled={item.disabled}
      data-testid={`reader-menu-${item.id}`}
      style={{
        display: 'flex', alignItems: 'center', gap: '0.85rem', width: '100%', minHeight: '48px',
        padding: '0.65rem 0.9rem', borderRadius: '10px', border: 'none', textAlign: 'left', cursor: 'pointer',
        background: item.active ? 'rgba(104,170,176,0.18)' : 'transparent',
        color: item.color || (isDarkMode ? '#e2e8f0' : '#e2e8f0'), fontSize: '0.95rem',
        transition: 'background-color 0.2s ease'
      }}
    >
      <Icon className="w-5 h-5" style={{ color: item.iconColor || item.color || '#a0aec0', fill: item.fill || 'none', flexShrink: 0 }} />
      <span style={{ flex: 1 }}>{item.label}</span>
      {item.badge && <span style={{ fontSize: '0.75rem', color: '#a0aec0' }}>{item.badge}</span>}
    </button>
  );
};

const ZoomRow = ({ scale, zoomIn, zoomOut }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 0.9rem', minHeight: '48px' }}>
    <span style={{ color: '#e2e8f0', fontSize: '0.95rem' }}>Zoom</span>
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <button onClick={zoomOut} data-testid="reader-menu-zoom-out" style={zoomBtn}><ZoomOut className="w-5 h-5" /></button>
      <span data-testid="reader-menu-zoom-value" style={{ color: '#a0aec0', minWidth: '48px', textAlign: 'center', fontSize: '0.9rem' }}>{Math.round(scale * 100)}%</span>
      <button onClick={zoomIn} data-testid="reader-menu-zoom-in" style={zoomBtn}><ZoomIn className="w-5 h-5" /></button>
    </div>
  </div>
);

const zoomBtn = {
  width: '44px', height: '44px', borderRadius: '10px', border: '1px solid #4a5568', background: 'transparent',
  color: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'
};

export const ReaderControlsMenu = ({ open, onClose, groups, isDarkMode, scale, zoomIn, zoomOut, title }) => (
  <>
    <div
      onClick={onClose}
      data-testid="reader-menu-backdrop"
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 6500,
        opacity: open ? 1 : 0, pointerEvents: open ? 'auto' : 'none', transition: 'opacity 0.25s ease'
      }}
    />
    <nav
      data-testid="reader-controls-menu"
      aria-hidden={!open}
      style={{
        position: 'fixed', top: 0, bottom: 0, left: 0, width: 'min(320px, 86vw)', zIndex: 6600,
        background: isDarkMode ? '#0f0f1a' : '#1a1f2e', borderRight: '1px solid #2d3748',
        transform: open ? 'translateX(0)' : 'translateX(-100%)', transition: 'transform 0.28s ease',
        display: 'flex', flexDirection: 'column', paddingBottom: 'env(safe-area-inset-bottom)'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem 1rem 0.75rem', borderBottom: '1px solid #2d3748' }}>
        <div style={{ minWidth: 0 }}>
          <p style={{ color: 'white', fontWeight: 600, fontSize: '1rem', margin: 0 }}>Controles</p>
          <p style={{ color: '#a0aec0', fontSize: '0.75rem', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</p>
        </div>
        <button onClick={onClose} data-testid="reader-menu-close-btn" style={{ ...zoomBtn, border: 'none' }}><X className="w-5 h-5" /></button>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '0.5rem' }}>
        {groups.map((group, gi) => (
          <div key={gi} style={{ paddingBottom: '0.4rem', marginBottom: '0.4rem', borderBottom: gi < groups.length - 1 ? '1px solid #2d3748' : 'none' }}>
            {group.map((item) => (item.id === 'zoom'
              ? <ZoomRow key="zoom" scale={scale} zoomIn={zoomIn} zoomOut={zoomOut} />
              : <MenuItem key={item.id} item={item} isDarkMode={isDarkMode} onPick={onClose} />))}
          </div>
        ))}
      </div>
    </nav>
  </>
);
